import { getLocalStorage, setLocalStorage } from "@/plugins/helpers";

function getLanguage() {
  var lang = getLocalStorage(process.env.VUE_APP_DEFAULT_LANGUAGE);
  if (!lang) {
    lang = getBrowserLanguage();
    setLocalStorage(process.env.VUE_APP_DEFAULT_LANGUAGE, lang);
  }
  return lang;
}

export function getBrowserLanguage() {
  var name = navigator.language.toLowerCase();
  if (name.includes("en") || name.includes("us")) return "en";
  return "vi";
}

const state = {
  lang: getLanguage(),
};

const getters = {
  getLang(state) {
    return state.lang;
  },
  getLangTranslateTo(state) {
    if (state.lang == "en") {
      return "vi";
    } else {
      return "en";
    }
  },
  getLangFull(state) {
    if (state.lang == "en") {
      return "en-US";
    } else {
      return "vi-VN";
    }
  },
};

const mutations = {
  SET_LANG(state, payload) {
    if (payload == "en" || payload == "vi") {
      state.lang = payload;
      setLocalStorage(process.env.VUE_APP_DEFAULT_LANGUAGE, payload);
    }
  },
};

export default {
  namespaced: "Lang",
  state,
  mutations,
  getters,
};
